import React, { useState, useEffect } from "react";
import { FaArrowRight, FaRegEdit } from "react-icons/fa";
import Header from "./Header/Header";
import Sidebar from "./Sidebar/Sidebar";
import { FaCircleCheck } from "react-icons/fa6";
import Switch from "react-switch";
import { MdContentCopy } from "react-icons/md";
import Footer from "./Footer/Footer";
import { RxCrossCircled } from "react-icons/rx";
import toast from "react-hot-toast";
import moment from "moment";

import { Oval } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";
import {
  useWeb3ModalAccount,
  useWeb3ModalProvider,
  useDisconnect,
} from "@web3modal/ethers/react";

import apiService from "../core/Service/detail";
import { getMethod, postMethod } from "../core/service/common.api";

const coinOptions = [
  {
    label: "USDT",
    img: "https://res.cloudinary.com/daafoiwvn/image/upload/v1726234202/vfq8obb4j4hfzj36vfih.png",
  },
  {
    label: "BNB",
    img: "https://res.cloudinary.com/taikonz-com/image/upload/v1664014615/fd2vqjmjipjxvzt6g2re.png",
  },
  {
    label: "ETH",
    img: "https://res.cloudinary.com/daafoiwvn/image/upload/v1726233359/mw0m6edznzjzfqfapazc.png",
  },
  {
    label: "Polygon",
    img: "https://res.cloudinary.com/dh3iko4f6/image/upload/v1758865883/Polygon_Icon.svg_mdlupr.png",
  },
];

const chainCoinMap = {
  56: ["BNB"],
  97: ["BNB"],
  137: ["Polygon"],
  1: ["ETH"],
};

const NETWORK_CONFIG = {
  1: { name: "Ethereum Mainnet", icon: "eth.webp", symbol: "ETH" },
  56: { name: "BNB Mainnet", icon: "bsc.png", symbol: "BNB" },
  97: { name: "BNB Testnet", icon: "bsc.png", symbol: "tBNB" },
  137: { name: "Polygon Mainnet", icon: "polygon.png", symbol: "MATIC" },
};

const timezones = [
  { label: "US/Pacific", value: "US/Pacific" },
  { label: "US/Mountain", value: "US/Mountain" },
  { label: "US/Central", value: "US/Central" },
  { label: "US/Eastern", value: "US/Eastern" },
  { label: "Europe/London", value: "Europe/London" },
];

function shortenAddress(address, start = 6, end = 4) {
  if (!address) return "";
  return `${address.slice(0, start)}...${address.slice(-end)}`;
}

const Profile = () => {
  const [loading, setLoading] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [selectedTimezone, setSelectedTimezone] = useState(timezones[0]);
  const [checked, setChecked] = useState(false);
  const { disconnect } = useDisconnect();
  const { walletProvider } = useWeb3ModalProvider();
  const { isConnected, chainId } = useWeb3ModalAccount();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [walletName, setWalletName] = useState(null);
  const [walletAddress, setWalletAddress] = useState(null);
  const [walletLogo, setWalletLogo] = useState(
    new URL("./../assets/wallet_connect.webp", import.meta.url)
  );
  const [walletLogo1, setWalletLogo1] = useState(
    new URL("./../assets/solf.png", import.meta.url)
  );
  const [isDisconnecting, setIsDisconnecting] = useState(false);
  const [walletType, setWalletType] = useState("");

  useEffect(() => {
    const savedCurrency = localStorage.getItem("preferredCurrency") || "usd";
    const WalletType = localStorage.getItem("WalletType");
    setWalletType(WalletType);

    const defaultCurrency =
      coinOptions.find(
        (opt) =>
          (savedCurrency === "usd" && opt.label === "USDT") ||
          (savedCurrency === "native" && opt.label !== "USDT")
      ) || coinOptions[0];

    setSelectedCurrency(defaultCurrency);
    const storedAddress = localStorage.getItem("userAddress");
    if (storedAddress) {
      getuser(storedAddress);
      setWalletAddress(storedAddress);
    } else {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    const connectedWallet = localStorage.getItem("@w3m/wallet_id");

    if (connectedWallet) {
      switch (connectedWallet.replace(/"/g, "")) {
        case "MetaMask":
          setWalletLogo(new URL("./../assets/metamask.png", import.meta.url));
          break;
        case "Coinbase Wallet":
          setWalletLogo(new URL("./../assets/coinbase.png", import.meta.url));
          break;
        case "Trust Wallet":
          setWalletLogo(
            new URL("./../assets/trustwallet.png", import.meta.url)
          );
          break;
        case "WalletConnect":
          setWalletLogo(
            new URL("./../assets/wallet_connect.webp", import.meta.url)
          );
          break;
        default:
          setWalletLogo(new URL("./../assets/metamask.png", import.meta.url));
      }
    }
  }, []);

  const disconnectWallet = async () => {
    try {
      setIsDisconnecting(true);
      await disconnect();
      localStorage.clear();
      toast.success("Wallet Disconnected");
      navigate("/");
    } catch (error) {
      console.log(error, "error disconnect");
    } finally {
      setIsDisconnecting(false);
    }
  };

  useEffect(() => {
    if (isConnected) {
      const Useradd = localStorage.getItem("userAddress");
      const storedWallet = localStorage.getItem("@w3m/wallet_id");
      setWalletName(storedWallet.replace(/"/g, ""));
      setWalletAddress(Useradd);
    }
  }, [isConnected]);

  const getuser = async (walletAddress) => {
    try {
      var loginHisObj = {
        walletAddress,
      };
      var data = {
        apiUrl: apiService.getuser,
        payload: loginHisObj,
      };
      var resp = await postMethod(data);
      if (resp.status == true) {
        setName(resp.data.username);
      } else {
        setName(walletAddress.substring(0, 8));
      }
    } catch (err) {
      console.log(err, "=-==-");
    }
  };

  const filteredOptions = coinOptions.filter(
    (opt) =>
      opt.label === "USDT" ||
      (chainId && chainCoinMap[chainId]?.includes(opt.label))
  );

  const handleCurrencySelect = (currency) => {
    setSelectedCurrency(currency);
    const prefCurrency = currency.label === "USDT" ? "usd" : "native";
    localStorage.setItem("preferredCurrency", prefCurrency);
    toast.success(`Currency preference set to ${prefCurrency.toUpperCase()}`);
  };

  const handleChange = (nextChecked) => {
    setChecked(nextChecked);
    toast.success(`2FA ${nextChecked ? "enabled" : "disabled"}`);
  };

  const switchNetwork = async (targetChainId) => {
    if (!walletProvider) {
      toast.error("Wallet not connected");
      return;
    }

    setLoading(true);

    try {
      await walletProvider.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: `0x${targetChainId.toString(16)}` }],
      });

      toast.success(`Switched to ${NETWORK_CONFIG[targetChainId]?.name}`);

      setTimeout(() => {
        window.location.reload();

        navigate("/dashboard");
      }, 1000);
    } catch (error) {
      if (error.code === 4902) {
        // If chain not added
        let chainData;
        const configs = {
          56: {
            chainId: "0x38",
            chainName: "Binance Smart Chain Mainnet",
            nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
            rpcUrls: ["https://bsc-dataseed.binance.org/"],
            blockExplorerUrls: ["https://bscscan.com/"],
          },
          97: {
            chainId: "0x61",
            chainName: "BSC Testnet",
            nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
            rpcUrls: ["https://data-seed-prebsc-1-s1.binance.org:8545/"],
            blockExplorerUrls: ["https://testnet.bscscan.com/"],
          },
          137: {
            chainId: "0x89",
            chainName: "Polygon Mainnet",
            nativeCurrency: { name: "MATIC", symbol: "MATIC", decimals: 18 },
            rpcUrls: ["https://polygon-rpc.com"],
            blockExplorerUrls: ["https://polygonscan.com/"],
          },
          1: {
            chainId: "0x1",
            chainName: "Ethereum Mainnet",
            nativeCurrency: { name: "ETH", symbol: "ETH", decimals: 18 },
            rpcUrls: ["https://mainnet.infura.io/v3/"],
            blockExplorerUrls: ["https://etherscan.io/"],
          },
        };

        chainData = configs[targetChainId];

        if (chainData) {
          await walletProvider.request({
            method: "wallet_addEthereumChain",
            params: [chainData],
          });
          toast.success("Chain added and switched");
          navigate("/dashboard");
        }
      } else {
        console.error("Switch error", error);
        toast.error(error.message || "Failed to switch network");
      }
    } finally {
      setLoading(false);
    }
  };

  const currentNetwork = NETWORK_CONFIG[chainId];

  const [transactions, setTransactions] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(3);
  const [totalPages, setTotalPages] = useState(1);

  const fetchTransactions = async (walletAddress) => {
    try {
      setLoading(true);

      var loginHisObj = {
        walletAddress,
        page,
        limit,
      };
      var data = {
        apiUrl: apiService.getTransactions,
        payload: loginHisObj,
      };

      var resp = await postMethod(data);
      if (resp.status) {
        setTransactions(resp.data.transactions);
        setTotalPages(resp.data.pagination.totalPages);
      } else {
        toast.error(resp.message || "Failed to load transactions");
      }
    } catch (error) {
      console.log(error);
      toast.error("Error loading transactions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const storedAddress = localStorage.getItem("userAddress");
    if (storedAddress) {
      fetchTransactions(storedAddress);
    }
  }, [page]);

  return (
    <>
      <Header />

      <main className="main_flx">
        <Sidebar />
        <div className="right_wrap">
          {loading ? (
            <div className="loading-overlay">
              <Oval color="#292B2C" secondaryColor="#D9D9D9" strokeWidth={2} height={75} width={75} />
            </div>
          ) : (
            <div>
              <div className="dsh_grid">

                <div className="dsh_grid_card grid_card_one">
                  <h4 className="dsh_subtitle">Personal Profile</h4>
                  <div className="dsh_profile_wrap">
                    <div className="dsh_pr_img_wrap">
                      <img
                        src={
                          new URL(
                            "./../assets/profile_img.webp",
                            import.meta.url
                          )
                        }
                        alt="Profile"
                        className="dsh_pr_img"
                      />
                    </div>
                    <div className="dsh_profile_cnt">
                      <div className="dsh_pr_flx">
                        <span>Display Name</span>
                        <p>
                          {name} <FaRegEdit />
                        </p>
                      </div>

                      <div className="dsh_pr_flx">
                        <span>Preferred Currency</span>
                        <div className="dropdown dsh_pr_dropdown">
                          <button
                            className="dropdown-toggle dsh_pr_dropdown_toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            {selectedCurrency && (
                              <span className="drp_lft_flx">
                                <img
                                  src={selectedCurrency.img}
                                  alt={selectedCurrency.label}
                                  width="20"
                                  height="20"
                                  style={{ borderRadius: "50%" }}
                                />
                                {selectedCurrency.label}
                              </span>
                            )}
                          </button>

                          <ul className="dropdown-menu dsh_pr_dropdown_menu">
                            {filteredOptions.map((opt) => (
                              <li key={opt.label}>
                                <button
                                  className="dropdown-item dsh_pr_dropdown_item"
                                  onClick={() => handleCurrencySelect(opt)}
                                  disabled={!chainId && opt.label !== "USDT"}
                                >
                                  <img
                                    src={opt.img}
                                    alt={opt.label}
                                    width="20"
                                    height="20"
                                    style={{ borderRadius: "50%" }}
                                  />
                                  {opt.label}
                                  {!chainId && opt.label !== "USDT" && (
                                    <small className="text-muted">
                                      {" "}
                                      (Connect wallet)
                                    </small>
                                  )}
                                </button>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>

                      <div className="dsh_pr_flx">
                        <span>Timezone</span>
                        <div className="dropdown dsh_pr_dropdown">
                          <button
                            className="dropdown-toggle dsh_pr_dropdown_toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <span className="drp_lft_flx">
                              {selectedTimezone.label}
                            </span>
                          </button>
                          <ul className="dropdown-menu dsh_pr_dropdown_menu">
                            {timezones.map((tz) => (
                              <li key={tz.value}>
                                <button
                                  className="dropdown-item dsh_pr_dropdown_item"
                                  onClick={() => setSelectedTimezone(tz)}
                                >
                                  {tz.label}
                                </button>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="dsh_profile_btn_wrap">
                      <button className="dsh_profile_btn">
                        Edit Profile Info
                      </button>
                    </div>
                  </div>
                </div>

                <div className="dsh_grid_card grid_card_two">
                  <h4 className="dsh_subtitle">Connected Network</h4>
                  <div className="dsh_cnt_box">
                    {chainId == 1 ? (
                      <div className="dsh_cnt_top">
                        <img
                          src={new URL("./../assets/eth.webp", import.meta.url)}
                          alt=""
                          className="dsh_cnt_img"
                        />
                        <span>Ethereum Mainnet</span>
                      </div>
                    ) : chainId == 56 ? (
                      <div className="dsh_cnt_top">
                        <img
                          src={new URL("./../assets/bsc.png", import.meta.url)}
                          alt=""
                          className="dsh_cnt_img"
                        />
                        <span>BNB Mainnet</span>
                      </div>
                    ) : chainId == 97 ? (
                      <div className="dsh_cnt_top">
                        <img
                          src={new URL("./../assets/bsc.png", import.meta.url)}
                          alt=""
                          className="dsh_cnt_img"
                        />
                        <span>BNB Testnet</span>
                      </div>
                    ) : chainId == 137 ? (
                      <div className="dsh_cnt_top">
                        <img
                          src={
                            new URL("./../assets/polygon.png", import.meta.url)
                          }
                          alt=""
                          className="dsh_cnt_img"
                        />
                        <span>Matic</span>
                      </div>
                    ) : (
                      <div className="dsh_cnt_top">
                        <img
                          src={
                            new URL("./../assets/sol.webp", import.meta.url)
                          }
                          alt=""
                          className="dsh_cnt_img"
                        />
                        <span>Solana</span>
                      </div>
                    )}


                    {walletType != "solflareWallet" ? (

                      <div className="dsh_profile_btn_wrap switch_nterwork_btn">
                        <button
                          className="dsh_profile_btn"
                          data-bs-toggle="modal"
                          data-bs-target="#Switchnetwork"
                          disabled={!isConnected}
                        >
                          {isConnected
                            ? "Switch Network"
                            : "Connect Wallet First"}
                        </button>
                      </div>
                    ) : ""}

                  </div>
                </div>

                <div className="dsh_grid_card grid_card_three">
                  <h4 className="dsh_subtitle">KYC Status</h4>
                  <div className="dsh_kyc_box">
                    <div className="dsh_kyc_top">
                      <span>Verification Type</span>
                      <span>Status</span>
                    </div>
                    <div className="dsh_kyc_flx_wrap">
                      <div className="dsh_kyc_flx">
                        <span className="dsh_kyc_lft">KYC</span>
                        <span className="dsh_kyc_rgt">
                          Verified <FaCircleCheck />
                        </span>
                      </div>
                      <div className="dsh_kyc_flx">
                        <span className="dsh_kyc_lft">Government ID</span>
                        <span className="dsh_kyc_rgt">
                          Submitted <FaCircleCheck />
                        </span>
                      </div>
                      <div className="dsh_kyc_flx">
                        <span className="dsh_kyc_lft">SSN/Tax ID</span>
                        <span className="dsh_kyc_rgt">
                          Submitted <FaCircleCheck />
                        </span>
                      </div>
                      <div className="dsh_kyc_flx">
                        <span className="dsh_kyc_lft">Proof of Address</span>
                        <span className="dsh_kyc_rgt">
                          Submitted <FaCircleCheck />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="dsh_grid_card grid_card_four">
                  <h4 className="dsh_subtitle">Security</h4>
                  <div className="dsh_security_box">
                    <div className="dsh_sec_flx">
                      <span className="dsh_sec_lft">
                        Two-Factor Authentication (2FA) / Biometric
                      </span>
                      <span>
                        <Switch
                          onChange={handleChange}
                          checked={checked}
                          onColor="#4ade80"
                          offColor="#d1d5db"
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={20}
                          width={40}
                          handleDiameter={18}
                        />
                      </span>
                    </div>
                    <div className="dsh_sec_flx">
                      <span className="dsh_sec_lft lft_fz">
                        {walletName ? walletName : "MetaMask"}
                      </span>
                      <span className="dsh_sec_rgt rgt_green">Connected</span>
                    </div>
                    <div className="dsh_sec_flx">
                      <span className="dsh_sec_lft lft_fz">
                        Coinbase Wallet
                      </span>
                      <span
                        className={`dsh_sec_rgt ${walletName === "Coinbase Wallet"
                          ? "rgt_green"
                          : "rgt_red"
                          }`}
                      >
                        {walletName === "Coinbase Wallet"
                          ? "Connected"
                          : "Not Connected"}
                      </span>
                    </div>
                    <div className="dsh_sec_flx">
                      <span className="dsh_sec_lft dsh_sec_bt">
                        Session History
                      </span>
                      <span className="dsh_sec_rgt dsh_sec_bt">
                        Last login: September 06, 2025, 02:03 PM PST (IP:
                        192.168.1.1, Chrome, Windows)
                      </span>
                    </div>
                  </div>
                </div>
                <div className="dsh_grid_card grid_card_five">
                  <h4 className="dsh_subtitle">Assetly Wallet</h4>
                  <div className="dsh_security_box cd_fv_hgt after_wallet_cont">

                    {walletType != "solflareWallet" ? (
                      <img
                        src={walletLogo}
                        alt="wallet-logo"
                        className="dsh_sec_img wallet-logo"
                      />
                    ) : (
                      <img
                        src={walletLogo1}
                        alt="wallet-logo"
                        className="dsh_sec_img wallet-logo"
                      />
                    )}
                    <p className="dsh_wlt_cnt">
                      {walletAddress ? shortenAddress(walletAddress) : "-"}
                    </p>
                    <div className="dsh_profile_btn_wrap mt-2">
                      <button
                        className="dsh_profile_btn"
                        onClick={disconnectWallet}
                        disabled={isDisconnecting}
                      >
                        {isDisconnecting
                          ? "Disconnecting..."
                          : "Disconnect Wallet"}
                      </button>
                    </div>
                  </div>
                </div>

                {/* Rest of your cards (KYC, Security, etc.) */}
                {/* ... Keep your existing KYC, Security, and other cards ... */}
              </div>
              <div className="dsh_row_two">
                <div className="row g-4">
                  <div className="col-xxl-9 col-xl-8 col-lg-7">
                    <div className="dsh_table_wrap">
                      <h4 className="dsh_subtitle">Transaction History</h4>
                      <div className="dsh_table_outer">
                        <div className="table-responsive">
                          <table className="table m-0 dsh_trans_table">
                            <thead className="dsh_trans_thead">
                              <tr>
                                <th>S.NO</th>
                                <th>Asset Name</th>
                                {/* <th>Transaction Hash</th> */}
                                <th>Amount</th>
                                <th>Date & Time</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <tbody className="dsh_trans_tbody">
                              {loading ? (
                                <tr>
                                  <td colSpan="6" className="text-center">
                                    Loading...
                                  </td>
                                </tr>
                              ) : transactions.length > 0 ? (
                                transactions.map((tx, index) => (
                                  <tr key={tx._id}>
                                    <td>{(page - 1) * limit + (index + 1)}</td>
                                    <td>
                                      {tx.propertyId?.fundName ||
                                        "Unknown Asset"}
                                    </td>
                                    {/* <td>
                                      <div className="dsh_trans_flx">
                                        <MdContentCopy
                                          onClick={() =>
                                            navigator.clipboard.writeText(
                                              tx.transactionHash
                                            )
                                          }
                                          style={{
                                            cursor: "pointer",
                                            marginRight: "6px",
                                          }}
                                        />
                                        {tx.transactionHash != null ? tx.transactionHash.slice(0, 10)+"..." : ""}
                                      </div>
                                    </td> */}
                                    <td>
                                      ${(tx.amountPaid || 0).toLocaleString()}
                                    </td>
                                    <td>
                                      {moment(tx.purchaseDate).format(
                                        "YYYY-MM-DD HH:mm:ss"
                                      )}
                                    </td>
                                    <td>
                                      <span
                                        className={`badge ${tx.status === "completed"
                                          ? "bg-success"
                                          : tx.status === "pending"
                                            ? "bg-warning"
                                            : "bg-danger"
                                          }`}
                                      >
                                        {tx.status}
                                      </span>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="6" className="text-center">
                                    No transactions found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      {/* Pagination Controls */}
                      <div className="pagination-controls nw_pagination_controls">
                        <button
                          disabled={page <= 1}
                          onClick={() => setPage(page - 1)}
                          className="nw_page_prev"
                        >
                          Previous
                        </button>
                        <span className="mx-3 nw_pge_cntr">
                          Page {page} of {totalPages}
                        </span>
                        <button
                          disabled={page >= totalPages}
                          onClick={() => setPage(page + 1)}
                          className="nw_page_nxt"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-4 col-lg-5">
                    <div className="dsh_tw_two_rgt">
                      <h4 className="dsh_subtitle">Tax Reporting Tools</h4>
                      <div className="dsh_tax_box">
                        <p>Generate tax-ready statements (1099 forms style)</p>
                        <div className="text-center">
                          <img
                            className="tax_prfo_img"
                            src={
                              new URL(
                                "./../assets/marketeq_tax_light.webp",
                                // tax_edit
                                import.meta.url
                              )
                            }
                            alt=""
                          />
                        </div>
                        <div className="dsh_profile_btn_wrap mt-2">
                          <button className="dsh_profile_btn">
                            Generate Tax Report
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              );
            </div>
          )}

          <div className="mt-5">
            <Footer />
          </div>
        </div>
      </main>

      {/* Network Switch Modal */}
      <div className="modal fade" id="Switchnetwork" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content wallet_modal_content">
            <div className="wallet_modal_head">
              <h4>
                Switch Network
                <span>
                  <RxCrossCircled data-bs-dismiss="modal" />
                </span>
              </h4>
              <p>Select a network to switch to</p>
            </div>
            <div className="wallet_modal_body">
              <div
                className="wlt_md_flx_outer"
                data-bs-dismiss="modal"
                onClick={() => switchNetwork(1)}
              >
                <div className="wlt_md_flx">
                  <img
                    src={new URL("./../assets/eth.png", import.meta.url)}
                    alt=""
                    className="wlt_md_icon"
                  />
                  <span>ETH</span>
                </div>
              </div>
              <div
                className="wlt_md_flx_outer"
                data-bs-dismiss="modal"
                onClick={() => switchNetwork(56)}
              >
                <div className="wlt_md_flx">
                  <img
                    src={new URL("./../assets/bsc.png", import.meta.url)}
                    alt=""
                    className="wlt_md_icon"
                  />
                  <span>BNB</span>
                </div>
              </div>

              <div
                className="wlt_md_flx_outer"
                data-bs-dismiss="modal"
                onClick={() => switchNetwork(137)}
              >
                <div className="wlt_md_flx">
                  <img
                    src={new URL("./../assets/polygon.png", import.meta.url)}
                    alt=""
                    className="wlt_md_icon"
                  />
                  <span>Polygon</span>
                </div>
              </div>

              <div
                className="wlt_md_flx_outer"
                data-bs-dismiss="modal"
                onClick={() => switchNetwork(97)}
              >
                <div className="wlt_md_flx">
                  <img
                    src={new URL("./../assets/bsc.png", import.meta.url)}
                    alt=""
                    className="wlt_md_icon"
                  />
                  <span>BSC Testnet</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
